export { default } from './assignIn.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/extend.js
// module id = 234
// module chunks = 0